import { Module } from 'vuex'
import i18n from '@/i18n'
import {
  User,
  Store
} from '@/types'
import apiFactory from '@api/settings'
import { get, set, unset, cloneDeep } from 'lodash'
import moment from 'moment-timezone'

const config: User.API.Config.Settings = {
  userInfoType: 'CUSTOM'
}

const api = apiFactory(config)
const defaultState: User.UserSettingsState = { lang: 'en' }

const storeModule: Module<User.UserSettingsState, Store.RootState> = {
  namespaced: true,
  state: cloneDeep(defaultState),
  mutations: {
    SET: (state, data: User.UserSettingsState | null | undefined) => {
      Object.assign(state, {}, data || defaultState)
      const { lang } = state
      if (lang) {
        i18n.locale = lang
        moment.updateLocale(
          'i18n',
          (i18n.getLocaleMessage(lang) as any).moment
        )
      }
    }
  },
  actions: {
    async Read ({ commit }) {
      commit('SET', await api.getInfo())
    },
    async CreateUpdate ({ commit, state }, { key, value }) {
      const clonedState = cloneDeep(state)
      set(clonedState, key, value)
      commit('SET', await api.setInfo(clonedState))
    },
    async Delete ({ commit, state }, { key }) {
      const clonedState = cloneDeep(state)
      const defaultValueAtKey = get(defaultState, key)
      if (defaultValueAtKey) {
        set(clonedState, key, defaultValueAtKey)
      }
      else {
        unset(clonedState, key)
      }
      commit('SET', await api.setInfo(clonedState))
    }
  },
  getters: {
    lang: state => state.lang
  }
}

export default storeModule
